import { useLocation } from 'react-router-dom';

export default function useShowLogin() {
  const params = new URLSearchParams(useLocation().search);

  return ! params.get('hideLogin');
};
